import request from '@/api/request'
// 修改基础项目信息
export const projectUpdate = (data) => {
    return request({
        url: '/project/doSubmit',
        method: 'POST',
        params: data
    })
}

// 更新 参加人
export const participantsUpdate = (params,data) => {
    return request({
        url: '/participants-user/doSubmitBatch',
        method: 'POST',
        data: data,
       headers: { 'Content-Type': 'application/json' },
        params: params
    })
}
// 修改用户信息
export const userUpdate = (data) => {
    return request({
        url: '/apply-user/update',
        method: 'POST',
        params: data
    })
}
// 修改推荐人
export const refereeUpdate = (data, params) => {
    return request({
        url: '/referee-user/doSubmitBatch',
        method: 'POST',
        data: data,
        headers: { 'Content-Type': 'application/json' },
        params: params
    })
}
// 修改课题论证
export const demonstrationUpdate = (data) => {
    return request({
        url: '/project-demonstration/doSubmit',
        method: 'POST',
        data: data
    })
}
// 修改预期成果
export const resultUpdate = (data, params) => {
    return request({
        url: '/research-result/doSubmitBatch?',
        method: 'POST',
        data: JSON.stringify(data),
        headers: { 'Content-Type': 'text/plain' },
        params: params
    })
}
// 修改推荐人意见
export const adviceUpdate = (data, params) => {
    return request({
        url: '/referee-advice/doSubmitBatch',
        method: 'POST',
        data: data,
        headers: { 'Content-Type': 'text/plain' },
        params: params
    })
}
// 修改所在单位意见
export const companyUpdate = (data) => {
    return request({
        url: '/company-advice/doSubmit',
        method: 'POST',
        params: data
    })
}
// 修改所在单位意见 委员会意见
export const expertsUpdate = (data) => {
    return request({
        url: '/experts-advice/doSubmit',
        method: 'POST',
        params: data
    })
}
// 修改专家评审
export const centerUpdate = (data) => {
    return request({
        url: '/center-review/doSubmitCenterReview',
        method: 'POST',
        params: data
    })
}
// 修改申请人个人资料
export const applyUpdate = (data) => {
    return request({
        url: '/apply-user/doSubmit',
        method: 'POST',
        params: data
    })
}
// 修改申请人个人资料
export const researchRemove = (data) => {
    return request({
        url: '/research-result/remove',
        method: 'POST',
        params: data
    })
}